import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import ImportTrucks from '@flc/components/logistics/import/trucks';
import ImportTruck from '@flc/components/logistics/import/truck';
import TransitTrucks from '@flc/components/logistics/transit/trucks';
import TransitTruck from '@flc/components/logistics/transit/truck';
import DeliveryTrucks from '@flc/components/logistics/delivery/trucks';
import DeliveryTruck from '@flc/components/logistics/delivery/truck';
import Remainings from '@flc/components/warehouse/remainings/remainings';
import Remaining from '@flc/components/warehouse/remainings/remaining';
import Performers from '@flc/components/warehouse/performer/performers';
import Consignees from '@flc/components/consignees/consignees';
import Consignee from '@flc/components/consignees/consignee';
import Users from '@flc/components/users/users';
import User from '@flc/components/users/user';
import UserAccount from '@flc/components/user-account/user-account';
import Balances from '@flc/components/balances/balances';
import BalanceDetails from '@flc/components/balances/balance-details';
import BillHeaders from '@flc/components/bills/bill-headers';

import Acceptance from '@components/acceptance/acceptance';
import WarehouseTruck from '@components/acceptance/warehouse-truck';
import WarehouseConsignment from '@components/acceptance/warehouse-consignment';
import ShipmentJournals from '@components/shipment-journals/shipment-journals';
import ShipmentJournal from '@components/shipment-journals/shipment-journal';
import RouteSheet from '@components/route-sheet/route-sheet';
import ManageRoutes from '@components/route-sheet/manage-routes';

import { ProtectedRoute } from '@controls/protected-route';
import RedirectRoute from '@controls/redirect-route';

import MainLayout from './main-layout';

import { IUserSession } from '@entities/user-session';

import { Permission, hasPermission } from '@enums/permission';

import { serverFetch } from '@src/server';

interface IAppRoutes {
    userSession: IUserSession;
    appVersion: string | undefined;
}

const AppRoutes = (props: IAppRoutes) => {
    const { userSession, appVersion } = props;

    return (
        <Routes>
            <Route path='/' element={<MainLayout appVersion={appVersion} />}>
                <Route index element={<RedirectRoute replace to={`/flc/logistics/transit`} />} />

                {/* TODO: remove redirect section */}

                <Route path='logistics/import' element={<RedirectRoute replace to={`/flc/logistics/import`} />} />
                <Route path='logistics/import/:id' element={<RedirectRoute replace to={`/flc/logistics/import/:id`} />} />
                <Route path='logistics/transit' element={<RedirectRoute replace to={`/flc/logistics/transit`} />} />
                <Route path='logistics/transit/:id' element={<RedirectRoute replace to={`/flc/logistics/transit/:id`} />} />

                <Route path='logistics/delivery' element={<RedirectRoute replace to={`/flc/logistics/delivery`} />} />
                <Route
                    path='logistics/delivery/new/:journalId'
                    element={<RedirectRoute replace to={`/flc/logistics/delivery/new/:journalId`} />}
                />
                <Route
                    path='logistics/delivery/:truckId/:journalId'
                    element={<RedirectRoute replace to={`/flc/logistics/delivery/:truckId/:journalId`} />}
                />

                <Route path='warehouse/acceptance' element={<RedirectRoute replace to={`/flc/warehouse/acceptance`} />} />
                <Route path='warehouse/acceptance/:id' element={<RedirectRoute replace to={`/flc/warehouse/acceptance/:id`} />} />
                <Route
                    path='warehouse/acceptance/consignments/:consignmentId'
                    element={<RedirectRoute replace to={`/flc/warehouse/acceptance/consignments/:consignmentId`} />}
                />
                <Route
                    path='warehouse/acceptance/consignments/:truckId/:markingCode'
                    element={<RedirectRoute replace to={`/flc/warehouse/acceptance/consignments/:truckId/:markingCode`} />}
                />
                <Route path='warehouse/remainings' element={<RedirectRoute replace to={`/flc/warehouse/remainings`} />} />
                <Route
                    path='warehouse/remainings/:boxGroupId'
                    element={<RedirectRoute replace to={`/flc/warehouse/remainings/:boxGroupId`} />}
                />
                <Route
                    path='warehouse/remainings/shipment/:journalId?'
                    element={<RedirectRoute replace to={`/flc/warehouse/remainings/shipment/:journalId?`} />}
                />
                <Route path='warehouse/shipmentjournals' element={<RedirectRoute replace to={`/flc/warehouse/shipmentjournals`} />} />
                <Route
                    path='warehouse/shipmentjournals/:id'
                    element={<RedirectRoute replace to={`/flc/warehouse/shipmentjournals/:id`} />}
                />
                <Route
                    path='warehouse/shipmentjournals/:journalId/truck/new'
                    element={<RedirectRoute replace to={`/flc/warehouse/shipmentjournals/:journalId/truck/new`} />}
                />
                <Route
                    path='warehouse/shipmentjournals/:journalId/truck/:truckId'
                    element={<RedirectRoute replace to={`/flc/warehouse/shipmentjournals/:journalId/truck/:truckId`} />}
                />
                <Route
                    path='warehouse/shipmentjournals/manageoutes/:journalId/:journalNumber'
                    element={<RedirectRoute replace to={`/flc/warehouse/shipmentjournals/manageoutes/:journalId/:journalNumber`} />}
                />
                <Route
                    path='warehouse/performers/:areaType/:truckId?'
                    element={<RedirectRoute replace to={`/flc/warehouse/performers/:areaType/:truckId?`} />}
                />
                <Route
                    path='warehouse/routesheet/:journalId'
                    element={<RedirectRoute replace to={`/flc/warehouse/routesheet/:journalId`} />}
                />
                <Route path='finance/bills/:userId?' element={<RedirectRoute replace to={`/flc/finance/bills/:userId?`} />} />
                <Route path='finance/balances' element={<RedirectRoute replace to={`/flc/finance/balances`} />} />
                <Route path='finance/balances/:userId' element={<RedirectRoute replace to={`/flc/finance/balances/:userId`} />} />
                <Route path='settings/consignees' element={<RedirectRoute replace to={`/flc/settings/consignees`} />} />
                <Route path='settings/consignees/:id' element={<RedirectRoute replace to={`/flc/settings/consignees/:id`} />} />
                <Route path='settings/users' element={<RedirectRoute replace to={`/flc/settings/users`} />} />
                <Route path='settings/users/new' element={<RedirectRoute replace to={`/flc/settings/users/new`} />} />
                <Route path='settings/users/:id' element={<RedirectRoute replace to={`/flc/settings/users/:id`} />} />
                <Route path='useraccount' element={<RedirectRoute replace to={`/flc/useraccount`} />} />

                {/* TODO: remove redirect section */}

                <Route path='flc/logistics/import' element={<ImportTrucks />} />
                <Route path='flc/logistics/import/:id' element={<ImportTruck />} />

                <Route path='flc/logistics/transit' element={<TransitTrucks />} />
                <Route path='flc/logistics/transit/:id' element={<TransitTruck />} />

                <Route path='flc/logistics/delivery' element={<DeliveryTrucks />} />
                <Route path='flc/logistics/delivery/new/:journalId' element={<DeliveryTruck />} />
                <Route path='flc/logistics/delivery/:truckId/:journalId' element={<DeliveryTruck />} />

                <Route path='flc/warehouse/acceptance' element={<Acceptance modulePath='flc' serverFetch={serverFetch} />} />
                <Route path='flc/warehouse/acceptance/:id' element={<WarehouseTruck modulePath='flc' serverFetch={serverFetch} />} />
                <Route
                    path='flc/warehouse/acceptance/consignments/:consignmentId'
                    element={<WarehouseConsignment serverFetch={serverFetch} />}
                />
                <Route
                    path='flc/warehouse/acceptance/consignments/:truckId/:markingCode'
                    element={<WarehouseConsignment serverFetch={serverFetch} />}
                />

                <Route path='flc/warehouse/remainings' element={<Remainings />} />
                <Route path='flc/warehouse/remainings/:boxGroupId' element={<Remaining />} />
                <Route path='flc/warehouse/remainings/shipment/:journalId?' element={<Remainings />} />

                <Route path='flc/warehouse/shipmentjournals' element={<ShipmentJournals modulePath='flc' serverFetch={serverFetch} />} />
                <Route path='flc/warehouse/shipmentjournals/:id' element={<ShipmentJournal modulePath='flc' serverFetch={serverFetch} />} />
                <Route path='flc/warehouse/shipmentjournals/:journalId/truck/new' element={<DeliveryTruck />} />
                <Route path='flc/warehouse/shipmentjournals/:journalId/truck/:truckId' element={<DeliveryTruck />} />
                <Route
                    path='flc/warehouse/shipmentjournals/manageoutes/:journalId/:journalNumber'
                    element={<ManageRoutes serverFetch={serverFetch} />}
                />

                <Route path='flc/warehouse/performers/:areaType/:truckId?' element={<Performers />} />
                <Route path='flc/warehouse/routesheet/:journalId' element={<RouteSheet serverFetch={serverFetch} />} />

                <Route
                    path='flc/finance/bills/:userId?'
                    element={
                        <ProtectedRoute
                            isAllowed={hasPermission(userSession.permissions, Permission.ViewTransportBill)}
                            redirectPath={'/'}
                            children={<BillHeaders />}
                        />
                    }
                />

                <Route
                    element={
                        <ProtectedRoute isAllowed={hasPermission(userSession.permissions, Permission.ViewBalance)} redirectPath={'/'} />
                    }
                >
                    <Route path='flc/finance/balances' element={<Balances />} />
                    <Route path='flc/finance/balances/:userId' element={<BalanceDetails />} />
                </Route>

                <Route path='flc/settings/consignees' element={<Consignees />} />
                <Route path='flc/settings/consignees/:id' element={<Consignee />} />

                <Route path='flc/settings/users' element={<Users />} />
                <Route path='flc/settings/users/new' element={<User />} />
                <Route path='flc/settings/users/:id' element={<User />} />

                <Route path='flc/useraccount' element={<UserAccount />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
